// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../../node_modules/@glennsl/bs-json/src/Json.bs.js";
import * as $$Array from "../../../node_modules/rescript/lib/es6/array.js";
import * as React from "react";
import * as ReactDom from "react-dom";
import * as Json_decode from "../../../node_modules/@glennsl/bs-json/src/Json_decode.bs.js";
import * as MarkdownBlock from "../shared/components/MarkdownBlock.bs.js";
import * as Caml_exceptions from "../../../node_modules/rescript/lib/es6/caml_exceptions.js";

var RootAttributeMissing = /* @__PURE__ */Caml_exceptions.create("ConvertMarkdownPack.RootAttributeMissing");

var InvalidProfile = /* @__PURE__ */Caml_exceptions.create("ConvertMarkdownPack.InvalidProfile");

function decodeProps(json) {
  return {
          markdown: Json_decode.field("markdown", Json_decode.string, json),
          profile: Json_decode.field("profile", Json_decode.string, json)
        };
}

function parseElement(element, attribute) {
  var props = element.getAttribute(attribute);
  var tmp;
  if (props == null) {
    throw {
          RE_EXN_ID: RootAttributeMissing,
          _1: attribute,
          Error: new Error()
        };
  }
  tmp = props;
  return decodeProps(Json.parseOrRaise(tmp));
}

function profileType(profile) {
  switch (profile) {
    case "areaOfText" :
        return /* AreaOfText */1;
    case "permissive" :
        return /* Permissive */0;
    default:
      throw {
            RE_EXN_ID: InvalidProfile,
            _1: profile,
            Error: new Error()
          };
  }
}

function parseMarkdown(attributeNameOpt, attributeOpt, param) {
  var attributeName = attributeNameOpt !== undefined ? attributeNameOpt : "convert-markdown";
  var attribute = attributeOpt !== undefined ? attributeOpt : "data-json-props";
  return $$Array.map((function (element) {
                var props = parseElement(element, attribute);
                ReactDom.render(React.createElement(MarkdownBlock.make, {
                          markdown: props.markdown,
                          className: "leading-normal text-sm",
                          profile: profileType(props.profile)
                        }), element);
              }), Array.prototype.slice.call(document.getElementsByClassName(attributeName)));
}

parseMarkdown(undefined, undefined, undefined);

export {
  RootAttributeMissing ,
  InvalidProfile ,
  decodeProps ,
  parseElement ,
  profileType ,
  parseMarkdown ,
}
/*  Not a pure module */
